import React, { Suspense } from 'react';
import Main from '../components/LandingPage/Main';
import { LoadingSkeleton } from '../components/LoadingSkeleton';

function MainRoute() {
    return <Suspense fallback={<LoadingSkeleton />}>{<Main />}</Suspense>;
}

export default React.memo(MainRoute);
